import { render, staticRenderFns } from "./SupplierReview.vue?vue&type=template&id=0303ee57&scoped=true&"
import script from "./SupplierReview.vue?vue&type=script&lang=js&"
export * from "./SupplierReview.vue?vue&type=script&lang=js&"
import style0 from "./SupplierReview.vue?vue&type=style&index=0&id=0303ee57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0303ee57",
  null
  
)

export default component.exports